export default __webpack_public_path__ + "static/media/Birds_of_Paradise_logo_timesheet.ec060b40.png";